"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Network = void 0;
var Network;
(function (Network) {
    Network["Ethereum"] = "ethereum";
    Network["Polygon"] = "polygon";
    Network["Arbitrum"] = "arbitrum";
    Network["BinanceSmartChain"] = "binancesmartchain";
    Network["Avalanche"] = "avalanche";
    Network["Fantom"] = "fantom";
    Network["xDai"] = "xdai";
})(Network = exports.Network || (exports.Network = {}));
//# sourceMappingURL=network.enum.js.map